export default __webpack_public_path__ + "static/media/bg_master_05.2bcfda10.jpg";